module.exports = __webpack_public_path__ + "static/media/peng-nutricia-combined-pocket-guide.0bd80ef9.pdf";